import type { ProFormColumnsType } from '@ant-design/pro-components';
import type { IntermediaryFee } from '@api/btlApplicationForm/types';
import { intermediaryFeesQuestions } from '@pages/ApplicationFormPage/IntermediaryFees/questions';
import type { TypedFormatMessageFn } from '@app-types/intl';
import { IntermediaryFeesReadOnlyTable } from '../CaseSummary/IntermediaryFeesReadOnlyTable';

interface IntermediaryFeesReadonlyFormSchemaProps {
  formatMessage: TypedFormatMessageFn;
  fees: IntermediaryFee[];
}

export function intermediaryFeesReadonlyFormSchema(
  props: IntermediaryFeesReadonlyFormSchemaProps,
): ProFormColumnsType[] {
  return [
    {
      title: props.formatMessage({ id: intermediaryFeesQuestions.hasIntermediaryFees.labelKey }),
      dataIndex: 'hasIntermediaryFees',
      valueType: 'radioButton',
      fieldProps: {
        options: [
          { label: props.formatMessage({ id: 'common.yes' }), value: 'true' },
          { label: props.formatMessage({ id: 'common.no' }), value: 'false' },
        ],
        buttonStyle: 'solid',
      },
    },
    {
      valueType: 'dependency',
      name: ['hasIntermediaryFees'],
      columns: ({ hasIntermediaryFees }) => {
        if (hasIntermediaryFees !== 'true') {
          return [];
        }

        return [
          {
            renderFormItem: () => <IntermediaryFeesReadOnlyTable fees={props.fees} />,
          },
        ];
      },
    },
  ];
}
